<article class="mt-[25vh] flex flex-col items-center">
    <ion-icon
        class="vl-app-light-dark:text-white h-32 w-32"
        *ngIf="onlyPortraitMode$ | async"
        [src]="
            env.ONBOARDING?.TNC_SPECIFIC_IMG
                ? (assetsPath$ | async) + '/img/onboarding/tnc_img.svg'
                : (assetsPath$ | async) + '/img/onboarding/language.svg'
        "
        aria-hidden="true"></ion-icon>
    <p
        class="sr-app-light:text-black mt-10 w-60 text-center text-base"
        [ngClass]="{ 'text-white': env.THEME_NAME !== 'varmland' }">
        {{ 'ONBOARDING_TERMS_AND_CONDITION_TEXT' | translate }}
    </p>
    <div
        class="terms w-10/12"
        [ngClass]="{ 'mt-32': onlyPortraitMode$ | async, 'text-center': (onlyPortraitMode$ | async) === false }">
        <span class="text-base" (click)="toggleTermsAgreed()">
            <ion-checkbox
                class="checkbox -mb-0.5 mr-2 mt-2"
                [checked]="termsAgreed"
                mode="md"
                slot="start"></ion-checkbox>
            <ion-label class="ml-0 inline" [ngClass]="{ 'text-white': env.THEME_NAME !== 'varmland' }">
                {{ 'READ_TERMS' | translate }}
            </ion-label>
        </span>
        <span
            class="pn-app-light:text-white pn-light:text-white gl-light:text-[var(--color-primary)] sr-app-light:text-[var(--color-secondary)] var-app-light:text-[var(--color-primary)] text-base text-white underline"
            (click)="handleShowTermsConditions()">
            {{ 'WITH_TERMS_AND_CONDITIONS' | translate }}</span
        >
    </div>
</article>
